import { tx } from "@transifex/native";

const TRANSIFEX_TOKEN = "1/69ca3203ac439b95df98636983f1e85c2878e4ab";

tx.init({
  token: TRANSIFEX_TOKEN,
});

export { T, useT } from "@transifex/react";
export { t } from "@transifex/native";
export { tx };
